import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {getNextId} from "../../util/misc";
import {ISearchParams, TBaseOrObservableType, TSyncfield} from "../../index";

export interface IPickerOptions<T> {
    observable?: KnockoutObservable<T | null>
    value?: TBaseOrObservableType<any>
    onSelect?: (o: T) => void
    label?: string
    placeholder?: string
    additionalSyncfieldKeys?: TSyncfield[]
    searchParams?: ISearchParams
}

export abstract class AbstractPicker<T> {
    private readonly componentId = `object-picker-${getNextId()}`;
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()
    protected readonly observable: KnockoutObservable<T | null>
    protected readonly label!: string
    private value: KnockoutObservable<any>;

    constructor(protected options: IPickerOptions<T>) {
        this.observable = options.observable ?? ko.observable<T | null>(null)
        this.value = ko.isObservable(options.value) ? options.value : ko.observable(null)

        if (options.onSelect) {
            this.kosub.subscribeChanged(this.observable, o => {
                if (o != null) {
                    this.options.onSelect?.(o)
                }
            })
        }

        this.init()
    }

    protected init(): Promise<any> {
        return Promise.resolve()
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }
}